import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from 'react-router-dom'
import './index.css';
import App from './App';
import { Toaster } from 'react-hot-toast';
import {VisitProvider} from "./context/VisitIdContext";
import { LocaleProvider } from './i18n/LocaleProvider';

const rootElement = document.getElementById("root");
const root = ReactDOMClient.createRoot(rootElement);


root.render(
    <BrowserRouter>
    <LocaleProvider>
        <VisitProvider>
      <App />
        </VisitProvider>
        <Toaster
            position='bottom-right'
            reverseOrder={false}
            gutter={8}
            containerClassName=''
            containerStyle={{}}
            toastOptions={{
                className: '',
                duration: 5000,
                style: {
                    background: '#000',
                    color: '#fff',
                    fontSize: '14px',
                },

                success: {
                    duration: 2000,
                    theme: {
                        primary: 'green',
                        secondary: 'black',
                    },
                },
                error: {
                    duration: 2000,
                    theme: {
                        primary: 'red',
                        secondary: 'black',
                    },
                },
            }}
        />

    </LocaleProvider>
    </BrowserRouter>,
  document.getElementById('root')
);
